var SCROLL_DIRECTION = {
    VERTICAL: 0,
    HORIZONTAL: 1,
};
export default SCROLL_DIRECTION;
//# sourceMappingURL=scrollDirection.js.map